import React, { FC, useEffect, useRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { TextAreaProps } from './textarea.types'
import useAutosizeTextAreaHeight from './useAutosizeTextAreaHeight'


const TextArea: FC<TextAreaProps> = ({
  value,
  className,
  placeholder,
  name,
  handleChange,
  customHeight = '',
  style = {}
}) => {
  const [textAreaValue, setTextAreaValue] = useState(value)

  const textAreaRef = useRef<HTMLTextAreaElement | null>(null)

  //hook to auto resize textArea height based on text and new line
  useAutosizeTextAreaHeight(textAreaRef.current, textAreaValue, customHeight)

  useEffect(() => {
    setTextAreaValue(value)
  }, [value])

  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // Get the new value from the textarea input
    const textValue = e.target.value

    // Update the textarea content state
    setTextAreaValue(textValue)

    if (handleChange) {
      handleChange(e)
    }
  }
  return (
    <div className={twMerge('flex rounded-lg border border-solid border-[1px] border-grey-20', className)} 
    >
      <textarea
        className="w-full resize-none overflow-hidden rounded-lg p-2 font-montserrat text-sm text-dark-gray placeholder:text-grey-30 hover:border-[#d9d9d9] hover:outline-0 focus:border-[#d9d9d9] focus:outline-0"
        placeholder={placeholder}
        onChange={handleTextAreaChange}
        name={name}
        value={textAreaValue}
        ref={textAreaRef}
        style={{
          // If custom height is passed then use custom height else normal defined height'.
          ...style,
          height: customHeight !== '' ? customHeight : 16.0,
        }}
      />
    </div>
  )
}

export default TextArea
